import { useTranslation } from "react-i18next"

import Table from "../../../../../Components/Table"
import EmptyCases from "../EmptyCases"
import { getColumns } from "./columns"

const CaseLookupTable = ({
  loading,
  data,
  totalCount,
  page,
  pageSize,
  columns,
  onChangeOrdering,
  onChangePage,
  onOpenCase
}) => {
  const { t } = useTranslation()
  const columnMap = getColumns({ t })

  const activeCols = (columns || [])
    .filter((c) => c.active !== false)
    .map((c) => columnMap[c.field_id])
    .filter(Boolean)

  const handleChange = (_pagination, _filters, sorter, extra) => {
    if (extra?.action !== "sort") return
    const field = sorter?.field
    if (!field || !sorter?.order) {
      onChangeOrdering(null)
      return
    }
    onChangeOrdering(sorter.order === "ascend" ? field : `-${field}`)
  }

  return (
    <Table
      loading={loading}
      dataSource={data || []}
      columns={activeCols}
      rowKey="id"
      onChange={handleChange}
      EmptyComponent={EmptyCases}
      pagination={{
        current: page,
        pageSize,
        total: totalCount,
        onChange: onChangePage
      }}
      scroll={{ x: 900 }}
      onRow={(record) => ({
        "data-testid": `deflect-ce-case-row-${record.id}`,
        onClick: () => onOpenCase(record.id),
        style: { cursor: "pointer" }
      })}
    />
  )
}

export default CaseLookupTable
